import React, { useEffect, useState } from "react";
import axios from "axios";

const Reviews = () => {
  const [companyReviews, setCompanyReviews] = useState([]);
  const [banner, setBannerData] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        // Fetch banners
        const bannerRes = await axios.get(
          "/prosapiens-cms/public/api/banners/reviews",
        );
        if (bannerRes.data.banners && bannerRes.data.banners.length > 0) {
          setBannerData(bannerRes.data.banners[0]);
        }

        // Fetch reviews
        const reviewRes = await axios.get(
          "/prosapiens-cms/public/api/content/reviews",
        );
        if (reviewRes.data.content) {
          setCompanyReviews(reviewRes.data.content);
        }
      } catch (error) {
        console.error("Error fetching reviews or banners:", error);
      }
    };

    fetchData();
  }, []);

  return (
    <>
      {banner && (
        <>
          {/* Desktop Banner */}
          <section
            className="reviews-bg"
            style={{
              backgroundImage: `url(/prosapiens-cms/public/${banner.banner_image})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
            }}
          >
            <div className="overlay container">
              <div className="hero-text">
                <div
                  style={{ color: "#fff" }}
                  dangerouslySetInnerHTML={{ __html: banner.content_text }}
                />
              </div>
            </div>
          </section>

          {/* Mobile Banner */}
          <section className="reviews-mobile">
            <div className="overlay container">
              <div className="hero-text">
                <div
                  dangerouslySetInnerHTML={{ __html: banner.content_text }}
                />
              </div>
            </div>
          </section>
        </>
      )}

      <section className="company-rev">
        <div className="container">
          <h2 className="section-heading">What Companies Say</h2>
          <div className="blog-grid">
            {companyReviews.map((review) => (
              <div key={review.id} className="blog-card">
                <div className="blog-content">
                  {/* Reviewer Image */}
                  {review.content_image && (
                    <div className="item">
                      <img
                        src={`/prosapiens-cms/public/${review.content_image}`}
                        alt={review.content_title}
                      />
                    </div>
                  )}

                  {/* Reviewer Name */}
                  <h3
                    className="blog-title"
                    dangerouslySetInnerHTML={{ __html: review.content_title }}
                  />

                  {/* Review Text */}
                  <div
                    className="blog-excerpt"
                    dangerouslySetInnerHTML={{ __html: review.content_text }}
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default Reviews;
